<div class="protocol-table-container" *ngIf="protocol">
  <!-- Protocol Header with Action Buttons -->
  <div class="protocol-header">
    <h4>{{protocol.name}} ({{protocol.code}})</h4>
    <div class="action-buttons" *ngIf="defaults.isMersyAdminUser  || defaults.isMersyAdminSafetySystemExcellence">
      <div class="OrangeButton" style="display: flex; gap: 10px;">
        <button mat-raised-button 
                (click)="addFactor()" 
                class="button-color-fix">
          <mat-icon class="icon-color-fix">add</mat-icon>
          Add Factor
        </button>
        <button mat-raised-button 
                (click)="toggleRemoveFactor()" 
                class="button-color-fix">
          <mat-icon class="icon-color-fix">remove_circle</mat-icon>
          Remove Factors
        </button>
      </div>
    </div>
  </div>

  <!-- Factors Table -->
  <app-data-table
      [columns]="tableColumns"
      [data]="protocolFactors"
      [emptyMessage]="emptyFactorsMessage">

    <ng-template #cellTemplate let-factor let-column="column">
      <!-- Code Column -->
      <ng-container *ngIf="column.key === 'code'">
        <div class="defCheckbox" [class.clickable-cursor]="isRemoveActive">
          <mat-checkbox *ngIf="isRemoveActive"
                        (click)="$event.stopPropagation();"
                        (change)="selectDeselectItem($event.checked, factor.id);">
          </mat-checkbox>
          <p [innerHTML]="factor.code || 'N/A'"></p>
        </div>
      </ng-container>

      <!-- Description Column -->
      <ng-container *ngIf="column.key === 'description'">
        <p [innerHTML]="factor.description || '-'"></p>
      </ng-container>
      <ng-container *ngIf="column.key === 'stage1'">
        <p [innerHTML]="factor.stage1 || '-'"></p>
      </ng-container>
      <ng-container *ngIf="column.key === 'stage2'">
        <p [innerHTML]="factor.stage2 || '-'"></p>
      </ng-container>
      <ng-container *ngIf="column.key === 'stage3'">
        <p [innerHTML]="factor.stage3 || '-'"></p>
      </ng-container>
      <ng-container *ngIf="column.key === 'stage4'">
        <p [innerHTML]="factor.stage4 || '-'"></p>
      </ng-container>

      <!-- Actions Column -->
      <ng-container *ngIf="column.key === 'actions'">
        <button mat-icon-button matTooltip="Edit Factor" (click)="$event.stopPropagation(); editFactor(factor)">
          <mat-icon>edit</mat-icon>
        </button>
        <button mat-icon-button matTooltip="Remove Factor" (click)="$event.stopPropagation(); deleteFactor(factor)">
          <mat-icon>delete</mat-icon>
        </button>
      </ng-container>

      <!-- Change Log Column -->
      <ng-container *ngIf="column.key === 'changeLog'">
        <button mat-icon-button class="branch-excellence-changelog-button" matTooltip="View Change Log" style="width:100%" (click)="$event.stopPropagation(); viewFactorHistory(factor)">
          <mat-icon>history</mat-icon>
          Get History
        </button>
      </ng-container>
    </ng-template>
  </app-data-table>

  <!-- Bulk Remove Panel -->
  <div *ngIf="isRemoveActive" class="stickypanel_KPI" style="margin-bottom:30px; margin-top:0">
    <div *ngIf="selection.hasValue()" class="col-lg-6" style="width:50%">
      Total selected factors: {{selection.selected.length}}
    </div>
    <div *ngIf="!selection.hasValue()" class="col-lg-6" style="width:50%">
      Please select at least one Factor to be removed Selective or click Remove All
    </div>
    <div class="col-lg-6">
      <button class="btn btn-realease btn-sm pull-right button-margin" (click)="onClickBulkRemove()">
        {{ textRemButtonState() }}
      </button>
    </div>
  </div>
</div>